import { Select } from "antd";
import CustomModalBody from "components/Modal/body";
import CustomModalFooter from "components/Modal/footer";
import { useState } from "react";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";

export default function FilterForm({
    onSubmit,
    onChangeHOC,
    handleState,
    plansList
}) {
    const [invoiceStartDate, setInvoiceStartDate] = useState(null);
    const [invoiceEndDate, setInvoiceEndDate] = useState(null);
    const [advertiserId, setAdvertiserId] = useState("");
    const [advertiser, setAdvertiser] = useState("");
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [billingName, setBillingName] = useState("");
    const [orderDesc, setOrderDesc] = useState("");
    const [plan, setPlan] = useState("");
    const [agentName, setAgentName] = useState("");
    const [agentID, setAgentID] = useState("");
    const [agentLeadID, setAgentLeadID] = useState("");
    const [agentLeadName, setAgentLeadName] = useState("");
    const [planId, setPlanId] = useState("");
    const [invoiceType, setInvoicecTyoe] = useState("");
    const [packageName, setPackageName] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [promoCode, setPromoCode] = useState("");
    const [printAdsReference, setPrintAdsReference] = useState("");
    const [paymentRefNo, setPaymentRefNo] = useState("");

    const handleClear = () => {
        setInvoiceStartDate("");
        setInvoiceEndDate("");
        setAdvertiserId("");
        setAdvertiser("");
        setBillingName("");
        setPlan("");
        setOrderDesc("");
        setInvoiceNumber("");
        setAgentName("");
        setAgentID("");
        setAgentLeadID("");
        setAgentLeadName("");
        setPlanId("");
        setInvoicecTyoe("");
        setPackageName("");
        setPaymentMethod("");
        setPromoCode("");
        setPrintAdsReference("");
        setPaymentRefNo("");
    };

    const generateQuery = () => {
        let queryString = "";

        if (invoiceStartDate) {
            queryString += `&invoice_start_date=${invoiceStartDate}`;
        }
        if (invoiceEndDate) {
            queryString += `&invoice_end_date=${invoiceEndDate}`;
        }
        if (invoiceNumber) {
            queryString += `&invoice_no=${invoiceNumber}`;
        }
        if (agentName) {
            queryString += `&agent_name=${agentName}`;
        }
        if (agentID) { queryString += `&agent_id=${agentID}` }
        if (agentLeadID) {
            queryString += `&agent_lead_id=${agentLeadID}`;
        }
        if (agentLeadName) {
            queryString += `&agent_lead_name=${agentLeadName}`;
        }
        if (advertiserId) {
            queryString += `&advertiser_id=${advertiserId}`;
        }
        if (advertiser) {
            queryString += `&company_name=${advertiser}`;
        }
        if (planId) {
            queryString += `&plan_id=${planId}`;
        }
        if (invoiceType) {
            queryString += `&order_invoice_type=${invoiceType}`;
        }
        if (packageName){ queryString += `&package_name=${packageName}`}
        if (plan){ queryString += `&plan_name=${plan}`}
        if (orderDesc){ queryString += `&order_description=${orderDesc}`}
        if (billingName){ queryString += `&billing_name=${billingName}`}
        if (paymentMethod){ queryString += `&payment_method=${paymentMethod}`}
        if (promoCode) { queryString += `&promo_code=${promoCode}` }
        if (printAdsReference){ queryString += `&print_ads_reference=${printAdsReference}`}
        if (paymentRefNo){ queryString += `&payment_reference_number=${paymentRefNo}`}

        return queryString;
    };

    return (
        <>
            <CustomModalBody>
                <Form id="billing-filter-form">
                    <Row>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceStartDate">Invoice Start Date </Label>
                                <Input
                                    type="date"
                                    placeholder="Enter Start Date"
                                    name="invoiceStartDate"
                                    id="invoiceStartDate"
                                    value={invoiceStartDate}
                                    onChange={(e) => {setInvoiceStartDate(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceEndDate">Invoice End Date </Label>
                                <Input
                                    type="date"
                                    placeholder="Enter "
                                    name="invoiceEndDate"
                                    id="invoiceEndDate"
                                    value={invoiceEndDate}
                                    onChange={(e) => {setInvoiceEndDate(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="invoiceNumber">Invoice No. </Label>
                                <Input
                                    placeholder="Enter Advertiser Name"
                                    name="invoiceNumber"
                                    id="invoiceNumber"
                                    value={invoiceNumber}
                                    onChange={(e) => {
                                        setInvoiceNumber(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="advertiser">Advertiser Name </Label>
                                <Input
                                    placeholder="Enter Advertiser Name"
                                    name="advertiser"
                                    id="advertiser"
                                    value={advertiser}
                                    onChange={(e) => {
                                        setAdvertiser(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="billingName">Billing Name </Label>
                                <Input
                                    placeholder="Enter Billing Name"
                                    name="billingName"
                                    id="billingName"
                                    value={billingName}
                                    onChange={(e) => {setBillingName(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="orderDesc">Order Description</Label>
                                <Input
                                    placeholder="Enter Order Description"
                                    name="orderDesc"
                                    id="orderDesc"
                                    value={orderDesc}
                                    onChange={(e) => {setOrderDesc(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="plan">Plan Name</Label>
                                <Input
                                    placeholder="Enter Plan Name"
                                    name="plan"
                                    id="plan"
                                    value={plan}
                                    onChange={(e) => {setPlan(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="paymentMethod">Payment Method</Label>
                                <Input
                                    placeholder="Enter Payment Method"
                                    name="paymentMethod"
                                    id="paymentMethod"
                                    value={paymentMethod}
                                    onChange={(e) => {setPaymentMethod(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="agentID">Agent ID</Label>
                                <Input
                                    placeholder="Enter Agent ID"
                                    name="agentID"
                                    id="agentID"
                                    value={agentID}
                                    onChange={(e) => {setAgentID(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="agentName">Agent Name </Label>
                                <Input
                                    placeholder="Enter Agent Name"
                                    name="agentName"
                                    id="agentName"
                                    value={agentName}
                                    onChange={(e) => {
                                        setAgentName(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="agentLeadID">Agent Lead ID</Label>
                                <Input
                                    placeholder="Enter Agent Lead ID"
                                    name="agentLeadID"
                                    id="agentLeadID"
                                    value={agentLeadID}
                                    onChange={(e) => {
                                        setAgentLeadID(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="agentLeadName">
                                    Agent Lead Name{" "}
                                </Label>
                                <Input
                                    placeholder="Enter Agent Lead Name"
                                    name="agentLeadName"
                                    id="agentLeadName"
                                    value={agentLeadName}
                                    onChange={(e) => {
                                        setAgentLeadName(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        {/* Comment for Further Use */}
                        {/* <Col lg={3}>
                            <FormGroup>
                                <Label for="descriptionOfProduct">
                                    Description of Product{" "}
                                </Label>
                                <Input
                                    type="select"
                                    placeholder="Select Description of Product"
                                    name="descriptionOfProduct"
                                    id="descriptionOfProduct"
                                    value={planId}
                                    onChange={(e) => {
                                        setPlanId(e.target.value);
                                    }}
                                >
                                    <option hidden>Select Description of Product</option>
                                    {
                                        plansList && 
                                        plansList.map((plan, index) => (
                                            <option key={index} value={plan.id}>{plan.name.en}</option>
                                        ))
                                    }
                                </Input>
                            </FormGroup>
                        </Col> */}
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="promoCode">Promo Code </Label>
                                <Input
                                    placeholder="Enter Promo Code"
                                    name="promoCode"
                                    id="promoCode"
                                    value={promoCode}
                                    onChange={(e) => {setPromoCode(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col lg={3}>
                            <FormGroup>
                                <Label for="printAdsReference">Print Ads Reference</Label>
                                <Input
                                    placeholder="Enter Print Ads Reference"
                                    name="printAdsReference"
                                    id="printAdsReference"
                                    value={printAdsReference}
                                    onChange={(e) => {setPrintAdsReference(e.target.value)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3}>
                            <FormGroup>
                                <Label for="paymentRefNo">Payment Ref No.</Label>
                                <Input
                                    placeholder="Enter Payment Ref No."
                                    name="paymentRefNo"
                                    id="paymentRefNo"
                                    value={paymentRefNo}
                                    onChange={(e) => {setPaymentRefNo(e.target.value)}}
                                />
                            </FormGroup>
                        </Col> */}
                    </Row>
                </Form>
            </CustomModalBody>
            <CustomModalFooter
                rightButton={[
                    {
                        color: "danger",
                        outline: true,
                        content: "Clear All",
                        onClick: () => handleClear(),
                    },
                    {
                        color: "primary",
                        content: "Submit",
                        onClick: () => {
                            const queryString = generateQuery();
                            onSubmit(queryString);
                            handleState({ filterQuery: queryString });
                            onChangeHOC("showFilterModal", false);
                            onChangeHOC("advertiserPages", 1);
                        },
                    },
                ]}
            />
        </>
    );
}
